import { FC } from 'react';
import { IconType } from './index';
import { DEFAULT_ICON_PROPS } from './helpers';

export const CarBoldIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <path
        data-color="color-2"
        d="M8,31H3a1,1,0,0,1-1-1V27H9v3A1,1,0,0,1,8,31Z"
        fill={color}
      />
      <path
        data-color="color-2"
        d="M29,31H24a1,1,0,0,1-1-1V27h7v3A1,1,0,0,1,29,31Z"
        fill={color}
      />
      <path
        d="M31.121,15.707,28.934,13.52,27.265,3.507A2.99,2.99,0,0,0,24.306,1H7.694A2.99,2.99,0,0,0,4.735,3.507L3.066,13.519.878,15.709A2.979,2.979,0,0,0,0,17.829V24a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V17.828A2.978,2.978,0,0,0,31.121,15.707ZM6.708,3.835A1,1,0,0,1,7.694,3H24.306a1,1,0,0,1,.986.835L26.82,13H5.18ZM6,22a2,2,0,1,1,2-2A2,2,0,0,1,6,22Zm20,0a2,2,0,1,1,2-2A2,2,0,0,1,26,22Z"
        fill={color}
      />
    </svg>
  );
};
